export const audioList = [
  {
    id: 21,
    name: "Downtown Boogie",
    url: "https://engageleads-gallery.s3.us-west-2.amazonaws.com/VidAmaze/templates/default_audios/DowntownBoogie.mp3",
  },
  {
    id: 22,
    name: "Energizing",
    url: "https://engageleads-gallery.s3.us-west-2.amazonaws.com/VidAmaze/templates/default_audios/Energizing.mp3",
  },
  {
    id: 23,
    name: "Flat Straight",
    url: "https://engageleads-gallery.s3.us-west-2.amazonaws.com/VidAmaze/templates/default_audios/FlatStraight.mp3",
  },
  {
    id: 24,
    name: "Lovely Piano Song",
    url: "https://engageleads-gallery.s3.us-west-2.amazonaws.com/VidAmaze/templates/default_audios/LovelySong.mp3",
  },
  {
    id: 25,
    name: "Planeteer Reaction",
    url: "https://engageleads-gallery.s3.us-west-2.amazonaws.com/VidAmaze/templates/default_audios/PlaneteerReaction.mp3",
  },
  {
    id: 26,
    name: "River Meditation",
    url: "https://engageleads-gallery.s3.us-west-2.amazonaws.com/VidAmaze/templates/default_audios/RiverMeditation.mp3",
  },
  {
    id: 27,
    name: "Study and Relax",
    url: "https://engageleads-gallery.s3.us-west-2.amazonaws.com/VidAmaze/templates/default_audios/StudyRelax.mp3",
  },
  {
    id: 28,
    name: "The Celebrated Minuet",
    url: "https://engageleads-gallery.s3.us-west-2.amazonaws.com/VidAmaze/templates/default_audios/TheMinuet.mp3",
  },

  {
    id: 29,
    name: "Arpent",
    url: "https://engageleads-gallery.s3.us-west-2.amazonaws.com/VidAmaze/templates/default_audios/Arpent.mp3",
  },
  {
    id: 30,
    name: "Beat Thee",
    url: "https://engageleads-gallery.s3.us-west-2.amazonaws.com/VidAmaze/templates/default_audios/BeatThee.mp3",
  },
  {
    id: 31,
    name: "Bit Bit Loop",
    url: "https://engageleads-gallery.s3.us-west-2.amazonaws.com/VidAmaze/templates/default_audios/BitBitLoop.mp3",
  },
  {
    id: 32,
    name: "Chronos",
    url: "https://engageleads-gallery.s3.us-west-2.amazonaws.com/VidAmaze/templates/default_audios/Chronos.mp3",
  },
  {
    id: 33,
    name: "Electronic I Crazy Fun",
    url: "https://engageleads-gallery.s3.us-west-2.amazonaws.com/VidAmaze/templates/default_audios/ElectronicFun.mp3",
  },
  {
    id: 34,
    name: "Fugue in Gee Miner",
    url: "https://engageleads-gallery.s3.us-west-2.amazonaws.com/VidAmaze/templates/default_audios/FugueinGeeMiner.mp3",
  },
  {
    id: 35,
    name: "Halloween Theme 1",
    url: "https://engageleads-gallery.s3.us-west-2.amazonaws.com/VidAmaze/templates/default_audios/HalloweenTheme1.mp3",
  },
  {
    id: 36,
    name: "Horned Flute Chill",
    url: "https://engageleads-gallery.s3.us-west-2.amazonaws.com/VidAmaze/templates/default_audios/HornedChill.mp3",
  },
  {
    id: 37,
    name: "Intrusion",
    url: "https://engageleads-gallery.s3.us-west-2.amazonaws.com/VidAmaze/templates/default_audios/Intrusion.mp3",
  },
  {
    id: 38,
    name: "We Wish You a Merry Christmas",
    url: "https://engageleads-gallery.s3.us-west-2.amazonaws.com/VidAmaze/templates/default_audios/MerryChristmas.mp3",
  },

  {
    id: 39,
    name: "Brewing Potions",
    url: "https://engageleads-gallery.s3.us-west-2.amazonaws.com/VidAmaze/templates/default_audios/BrewingPotions.mp3",
  },
  {
    id: 40,
    name: "Celebration",
    url: "https://engageleads-gallery.s3.us-west-2.amazonaws.com/VidAmaze/templates/default_audios/Celebration.mp3",
  },
  {
    id: 41,
    name: "Land of Pirates",
    url: "https://engageleads-gallery.s3.us-west-2.amazonaws.com/VidAmaze/templates/default_audios/LandPirates.mp3",
  },
  {
    id: 42,
    name: "Magical Transition",
    url: "https://engageleads-gallery.s3.us-west-2.amazonaws.com/VidAmaze/templates/default_audios/MagicalTransition.mp3",
  },
  {
    id: 43,
    name: "Nomadic Sunset MMXIX",
    url: "https://engageleads-gallery.s3.us-west-2.amazonaws.com/VidAmaze/templates/default_audios/NomadicMMXIX.mp3",
  },
  {
    id: 44,
    name: "One Step Closer",
    url: "https://engageleads-gallery.s3.us-west-2.amazonaws.com/VidAmaze/templates/default_audios/OnetepCloser.mp3",
  },
  {
    id: 45,
    name: "Painting Room",
    url: "https://engageleads-gallery.s3.us-west-2.amazonaws.com/VidAmaze/templates/default_audios/PaintingRoom.mp3",
  },
  {
    id: 46,
    name: "The Britons",
    url: "https://engageleads-gallery.s3.us-west-2.amazonaws.com/VidAmaze/templates/default_audios/TheBritons.mp3",
  },
  {
    id: 47,
    name: "The Vikings",
    url: "https://engageleads-gallery.s3.us-west-2.amazonaws.com/VidAmaze/templates/default_audios/TheVikings.mp3",
  },
  {
    id: 48,
    name: "Ukulele Song",
    url: "https://engageleads-gallery.s3.us-west-2.amazonaws.com/VidAmaze/templates/default_audios/UkuleleSong.mp3",
  },
  {
    id: 49,
    name: "Taboom",
    url: "https://engageleads-gallery.s3.us-west-2.amazonaws.com/VidAmaze/templates/default_audios/Taboom.mp3",
  },
  {
    id: 50,
    name: "Pickled Pink",
    url: "https://engageleads-gallery.s3.us-west-2.amazonaws.com/VidAmaze/templates/default_audios/PickledPink.mp3",
  },
  {
    id: 1,
    name: "goodbye stress calming acoustic guitar",
    url: "https://engageleads-gallery.s3.us-west-2.amazonaws.com/compareshopvideo/audios/7.mp3",
  },
  {
    id: 2,
    name: "funky trap sax",
    url: "https://engageleads-gallery.s3.us-west-2.amazonaws.com/compareshopvideo/audios/2.mp3",
  },
  {
    id: 3,
    name: "soft instrumental hip hop",
    url: "https://engageleads-gallery.s3.us-west-2.amazonaws.com/compareshopvideo/audios/3.mp3",
  },
  {
    id: 4,
    name: "future bass beat",
    url: "https://engageleads-gallery.s3.us-west-2.amazonaws.com/compareshopvideo/audios/4.mp3",
  },
  {
    id: 5,
    name: "stomp and claps",
    url: "https://engageleads-gallery.s3.us-west-2.amazonaws.com/compareshopvideo/audios/6.mp3",
  },
  {
    id: 6,
    name: "epic",
    url: "https://engageleads-gallery.s3.us-west-2.amazonaws.com/compareshopvideo/audios/1.mp3",
  },
  {
    id: 7,
    name: "dreamy piano soft sound ambient",
    url: "https://engageleads-gallery.s3.us-west-2.amazonaws.com/compareshopvideo/audios/10.mp3",
  },
  {
    id: 8,
    name: "innovation",
    url: "https://engageleads-gallery.s3.us-west-2.amazonaws.com/compareshopvideo/audios/11.mp3",
  },

  {
    id: 9,
    name: "Happy Hop",
    url: "https://engageleads-gallery.s3.us-west-2.amazonaws.com/VidAmaze/templates/default_audios/a432.mp3",
  },
  {
    id: 10,
    name: "Cheap Arp Guitar",
    url: "https://engageleads-gallery.s3.us-west-2.amazonaws.com/VidAmaze/templates/default_audios/CheapArpGuitar.mp3",
  },
  {
    id: 11,
    name: "Chill Beat",
    url: "https://engageleads-gallery.s3.us-west-2.amazonaws.com/VidAmaze/templates/default_audios/ChillBeat.mp3",
  },
  {
    id: 12,
    name: "Chill C",
    url: "https://engageleads-gallery.s3.us-west-2.amazonaws.com/VidAmaze/templates/default_audios/ChillC.mp3",
  },
  {
    id: 13,
    name: "Chill Breathe",
    url: "https://engageleads-gallery.s3.us-west-2.amazonaws.com/VidAmaze/templates/default_audios/ChillBreathe.mp3",
  },
  {
    id: 14,
    name: "Chill Deep",
    url: "https://engageleads-gallery.s3.us-west-2.amazonaws.com/VidAmaze/templates/default_audios/ChillDeep.mp3",
  },
  {
    id: 15,
    name: "Chill Float",
    url: "https://engageleads-gallery.s3.us-west-2.amazonaws.com/VidAmaze/templates/default_audios/ChillFloat.mp3",
  },
  {
    id: 16,
    name: "Chill Openness",
    url: "https://engageleads-gallery.s3.us-west-2.amazonaws.com/VidAmaze/templates/default_audios/ChillOpenness.mp3",
  },
  {
    id: 17,
    name: "Waterlilies 1",
    url: "https://engageleads-gallery.s3.us-west-2.amazonaws.com/VidAmaze/templates/default_audios/Waterlilies1.mp3",
  },
  {
    id: 18,
    name: "Tapped Piano",
    url: "https://engageleads-gallery.s3.us-west-2.amazonaws.com/VidAmaze/templates/default_audios/TappedPiano.mp3",
  },

  {
    id: 19,
    name: "Aquarium",
    url: "https://engageleads-gallery.s3.us-west-2.amazonaws.com/VidAmaze/templates/default_audios/Aquarium.mp3",
  },
  {
    id: 20,
    name: "Champ de tournesol",
    url: "https://engageleads-gallery.s3.us-west-2.amazonaws.com/VidAmaze/templates/default_audios/Champdetournesol.mp3",
  },
];
